/* eslint-disable */
export default {
  start: 'Katso esittely',
  skip: 'Ohita',
  next: 'Seuraava',
  finish: 'Valmis',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
